import { parseLCVModel } from '@/components/shared/utility/contentstack';
import {
  MU_X_CLASS,
  PICK_UP_2_DOOR_CLASS,
  PICK_UP_4_DOOR_CLASS,
  PRODUCT_CUSTOMIZE_SKIP_GRADE_LIST,
  SPARK_CLASS,
  UID_2_DOOR_ORDER,
  UID_4_DOOR_ORDER,
  UID_MUX_ORDER,
  UID_SPARK_ORDER,
  UID_V_CROSS_ORDER,
  UID_X_SERIES_ORDER,
  V_CROSS_CLASS,
  X_SERIES_CLASS,
} from '@/const/product';
import { ILCVModelCategory } from '@/types/lcv/model';

export const parseMenuData = (entry) => {
  const menu: any[] = [];
  for (const i in entry) {
    const section = entry[i];
    if (
      section.active &&
      section.menu &&
      section.menu.hash &&
      // section.menu.hash !== '#video' &&
      section.menu.label
    ) {
      menu.push(section.menu);
    }
  }
  return menu;
};

export const parseModelData = (data) => {
  return data
    .map((o) => parseLCVModel(o))
    .filter((o) => !PRODUCT_CUSTOMIZE_SKIP_GRADE_LIST.includes(o.uid));
};

export const sortModel = (data: ILCVModelCategory[]) => {
  const SORT_KEY = [
    V_CROSS_CLASS,
    PICK_UP_4_DOOR_CLASS,
    PICK_UP_2_DOOR_CLASS,
    SPARK_CLASS,
    X_SERIES_CLASS,
    MU_X_CLASS,
  ];

  const idToObjMap = new Map(data.map((obj) => [obj.uid, obj]));
  const sortedArray = SORT_KEY.map((uid) => idToObjMap.get(uid));

  return sortedArray.filter((obj) => obj);
};

interface IModelGrade {
  uid: string;
  name: string;
}

export const sortVcross = (data) => {
  const idToObjMap = new Map(data.map((obj) => [obj.uid, obj]));
  const sortedArray = UID_V_CROSS_ORDER.map((uid) => idToObjMap.get(uid));

  return sortedArray.filter((obj) => obj) as IModelGrade[];
};
export const sort4Door = (data) => {
  const idToObjMap = new Map(data.map((obj) => [obj.uid, obj]));
  const sortedArray = UID_4_DOOR_ORDER.map((uid) => idToObjMap.get(uid));

  return sortedArray.filter((obj) => obj) as IModelGrade[];
};

export const sort2Door = (data) => {
  const idToObjMap = new Map(data.map((obj) => [obj.uid, obj]));
  const sortedArray = UID_2_DOOR_ORDER.map((uid) => idToObjMap.get(uid));

  return sortedArray.filter((obj) => obj) as IModelGrade[];
};

export const sortSpark = (data) => {
  const idToObjMap = new Map(data.map((obj) => [obj.uid, obj]));
  const sortedArray = UID_SPARK_ORDER.map((uid) => idToObjMap.get(uid));

  return sortedArray.filter((obj) => obj) as IModelGrade[];
};

export const sortXseries = (data) => {
  const idToObjMap = new Map(data.map((obj) => [obj.uid, obj]));
  const sortedArray = UID_X_SERIES_ORDER.map((uid) => idToObjMap.get(uid));

  return sortedArray.filter((obj) => obj) as IModelGrade[];
};

export const sortMux = (data) => {
  const idToObjMap = new Map(data.map((obj) => [obj.uid, obj]));
  const sortedArray = UID_MUX_ORDER.map((uid) => idToObjMap.get(uid));

  return sortedArray.filter((obj) => obj) as IModelGrade[];
};
